import { useState } from "react";
import { useDispatch } from "react-redux";
import * as services from "../../store/service";
import * as CSIDActions from "../../store/csid/actions";
import { ICSIDUserStatus } from "../../store/csid/types";
import * as csidUtil from "../../components/csid/csid";

const AlertDetailContainer = () => {
    const dispatch = useDispatch();
    const [isIDFuser, setIsIDFUser] = useState(false);
    const [csidUserStatus, setCSIDUserStatus] = useState({} as ICSIDUserStatus);
    const [showAuthenticatedPage, setShowAuthenticatedPage] = useState(false);
    const [initComplete, setInitComplete] = useState(false);
    const [showCreditAuth, setShowCreditAuth] = useState(false);
    const refreshContext = () => dispatch(CSIDActions.actionCreators.componentNeedsRefresh());
    const [showAlertDetails, setShowAlertDetails] = useState(false);
    const [yScroll, setYScroll] = useState(0);
    const [alert, setAlert] = useState({});
    const [l3Auth, setL3Auth] = useState(false);

    const getUserCSIDStatus = () => {
        services
            .getUserCSIDStatus()
            .then((data) => {
                const csidUserStatus: ICSIDUserStatus = data as ICSIDUserStatus;
                setIsIDFUser(csidUserStatus.isIDFUser);
                setCSIDUserStatus(csidUserStatus);
                if (csidUserStatus.isIDFUser) {
                    if (csidUserStatus["auth-status"] != null && csidUserStatus["auth-status"].toUpperCase() === "AUTHENTICATED") {
                        setShowAuthenticatedPage(true);
                    }
                } else {
                    const nextStep: csidUtil.NEXT_STEP = csidUtil.getNextStep(csidUserStatus);
                    switch (nextStep) {
                        case csidUtil.NEXT_STEP.GO_TO_DASHBOARD:
                            setShowAuthenticatedPage(true);
                            break;
                        default:
                            break;
                    }
                }
                if (initComplete === false) {
                    setInitComplete(true);
                }
                dispatch(CSIDActions.actionCreators.updateCSIDStatus(csidUserStatus));
            })
            .catch((error) => {
                if (initComplete === false) {
                    setInitComplete(true);
                }
            });
    };

    const creditAuthSuccessCallBack = (callbackObj: any) => {
        getUserCSIDStatus();
        setShowCreditAuth(false);
        refreshContext();
        setYScroll(scrollY);
        setShowAlertDetails(true);
    };

    const alertDetails = (alert: any) => {
        if (alert.isCreditAlert) {
            setAlert(alert);
            services.getUserCSIDStatus().then((data) => {
                if (data["auth-status"] != null && data["auth-status"].toUpperCase() !== "AUTHENTICATED" && !data.isIDFUser) {
                    setL3Auth(true);
                } else {
                    setAlert(alert);
                    setYScroll(scrollY);
                    setShowAlertDetails(true);
                }
            });
        } else if (alert.serviceType === "AdvancedFraudMonitoring") {
            setAlert(alert);
            services.getUserCSIDStatus().then((data) => {
                const csidUserStatus: ICSIDUserStatus = data as ICSIDUserStatus;
                setIsIDFUser(csidUserStatus.isIDFUser);
                setCSIDUserStatus(csidUserStatus);
                if (csidUserStatus.isIDFUser) {
                    if (csidUserStatus["auth-status"] != null && csidUserStatus["auth-status"].toUpperCase() === "AUTHENTICATED") {
                        creditAlertDetailsCallback(alert);
                    } else {
                        setShowCreditAuth(true);
                    }
                } else {
                    creditAlertDetailsCallback(alert);
                }
            });
        } else {
            setAlert(alert);
            setYScroll(scrollY);
            setShowAlertDetails(true);
        }
    };

    const creditAlertDetailsCallback = (alert: any) => {
        setAlert(alert);
        setYScroll(scrollY);
        setShowAlertDetails(true);
    };

    const closeDisclosureDialogCallBack = (callbackObj: any) => {
        setShowCreditAuth(false);
        setShowAlertDetails(false);
        refreshContext();
    };

    return {
        showAlertDetails,
        setShowAlertDetails,
        yScroll,
        alertDetails,
        setAlert,
        alert,
        l3Auth,
        setL3Auth,
        creditAlertDetailsCallback,
        setIsIDFUser,
        isIDFuser,
        csidUserStatus,
        setCSIDUserStatus,
        showCreditAuth,
        setShowCreditAuth,
        creditAuthSuccessCallBack,
        closeDisclosureDialogCallBack,
    };
};

export default AlertDetailContainer;
